import React from 'react';

const AdminLayout = ({ title, children }) => {
  return (
    <div className="p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="mb-0">{title}</h2>
      </div>
      {children}
    </div>
  );
};

export default AdminLayout;